// Use this as a fallback if value is not returned by the API
export const HEALTH_INSURANCE_PER_DIEM_RATE = "1.01";

export const TYPE_PAYSLIP = "payslips";
export const TYPE_WAGE_REPORT = "wageReports";
export const TYPE_EMPLOYER_HEALTH_INSURANCE_REDUCTION =
  "employerHealthInsuranceReductions";
export const TYPES = [
  { name: "payslips", value: TYPE_PAYSLIP },
  { name: "wageReports", value: TYPE_WAGE_REPORT },
  {
    name: "employerHealthInsuranceReductions",
    value: TYPE_EMPLOYER_HEALTH_INSURANCE_REDUCTION,
  },
];

export const PAYSLIP_DRAFT = "Draft";
export const PAYSLIP_APPROVED = "Approved";
export const PAYSLIP_LOCKED = "Locked";
export const PAYSLIP_ASSIGNED_TO_PAYMENT = "AssignedToPayment";

export const PAYSLIP_STATUS = [
  { name: "draft", value: PAYSLIP_DRAFT },
  { name: "approved", value: PAYSLIP_APPROVED },
  { name: "locked", value: PAYSLIP_LOCKED },
  {
    name: "assignedToPayment",
    value: PAYSLIP_ASSIGNED_TO_PAYMENT,
  },
];

export const WAGE_REPORT_STATUS_VALID = { name: "valid", value: "Valid" };

export const WAGE_REPORT_STATUS = [
  { name: "unknown", value: "Unknown" },
  { name: "inProcess", value: "InProcess" },
  WAGE_REPORT_STATUS_VALID,
  { name: "rejectedAtReception", value: "RejectedAtReception" },
  { name: "rejectedDuringProcessing", value: "RejectedDuringProcessing" },
  { name: "invalidated", value: "Invalidated" },
  { name: "notInIncomeRegister", value: "NotInIncomeRegister" },
];
